
export const accounts = {
  'accounts.title': 'Investment Accounts',
  'accounts.subtitle': 'View and manage your investment accounts',
  'accounts.loading': 'Loading accounts...',
  'accounts.error': 'Error loading accounts',
  'accounts.noAccounts': 'No investment accounts found',
  'accounts.accountNumber': 'Account Number',
  'accounts.balance': 'Balance',
  'accounts.accountShare': 'Account Share',
  'accounts.accountOpen': 'Account Opened',
  'accounts.broker': 'Broker',
  'accounts.active': 'Active',
  'accounts.inactive': 'Inactive',
  'accounts.pending': 'Pending',
  'accounts.closed': 'Closed',
  
  // Transactions section
  'accounts.transactions.title': 'Account Transactions',
  'accounts.transactions.subtitle': 'View your deposits and withdrawals history',
  'accounts.transactions.loading': 'Loading transactions...',
  'accounts.transactions.error': 'Error loading transactions',
  'accounts.transactions.noTransactions': 'No transactions found',
  'accounts.transactions.export': 'Export CSV',
  'accounts.transactions.loadMore': 'Load More',
  
  // Table columns
  'accounts.transactions.table.account': 'Account',
  'accounts.transactions.table.date': 'Date',
  'accounts.transactions.table.amount': 'Amount',
  'accounts.transactions.table.operation': 'Operation',
  
  // Operations
  'accounts.transactions.deposit': 'Deposit',
  'accounts.transactions.withdrawal': 'Withdrawal',
  
  // Filters
  'accounts.transactions.filters.account': 'Filter by Account',
  'accounts.transactions.filters.operation': 'Filter by Operation',
  'accounts.transactions.filters.dateFrom': 'From Date',
  'accounts.transactions.filters.dateTo': 'To Date',
  'accounts.transactions.filters.apply': 'Apply Filters',
  'accounts.transactions.filters.reset': 'Reset Filters',
  'accounts.transactions.filters.allAccounts': 'All Accounts',
  'accounts.transactions.filters.allOperations': 'All Operations',
  
  // Add Account section
  'accounts.addAccount.title': 'Add PAMM Investment Account',
  'accounts.addAccount.subtitle': 'Provide PAMM Account Id and Associated Email',
  'accounts.addAccount.pammAccount': 'PAMM Account',
  'accounts.addAccount.associatedEmail': 'Associated Email',
  'accounts.addAccount.validateAccount': 'Validate Account',
  'accounts.addAccount.instructionsTitle': 'Follow below instructions to find your PAMM Account',
  'accounts.addAccount.step1.title': 'Logging to your PAMM account using the credential received in your email',
  'accounts.addAccount.step1.substep1': 'Look for an email with subject: "RADEX MARKETS - Successfully joined PAMM of the money manager - The Club Funding Pro"',
  'accounts.addAccount.step1.substep2': 'Open the link provided in the email: https://pamm.radexmarkets.com/app/auth/investor',
  'accounts.addAccount.step2.title': 'Obtain your PAMM Account Id from the Radex Markets Portal you just signed in',
  'accounts.addAccount.step2.description': 'The PAMM Account Id is highlighted in the below image',
  'accounts.addAccount.validation.pammAccountRequired': 'PAMM Account is required',
  'accounts.addAccount.validation.pammAccountInvalid': 'PAMM Account must be a positive number',
  'accounts.addAccount.validation.emailRequired': 'Associated Email is required',
  'accounts.addAccount.validation.emailInvalid': 'Please enter a valid email address',
  'accounts.addAccount.success': 'Account validated successfully',
  'accounts.addAccount.error': 'Error validating account',
  'accounts.addAccount.validating': 'Validating account...',
  'accounts.addAccount.successDescription': 'Your investment account has been successfully added.',
  
  // Error messages
  'accounts.addAccount.messages.success': 'Account validated and added successfully',
  'accounts.addAccount.messages.missing_fields': 'Please fill in all required fields',
  'accounts.addAccount.messages.account_exists': 'This investment account is already registered',
  'accounts.addAccount.messages.account_already_registered': 'This account cannot be registered',
  'accounts.addAccount.messages.account_not_active': 'Account is not active. Please ensure your account is active before validation',
  'accounts.addAccount.messages.account_validation_failed': 'Account validation failed. Please verify your account number and email address',
  'accounts.addAccount.messages.insert_failed': 'Failed to register the account. Please try again',
  'accounts.addAccount.messages.server_error': 'An error occurred. Please try again later',
  'accounts.addAccount.messages.systemError': 'The operation failed, try later or contact Customer Support',
  
  // Placeholders
  'accounts.addAccount.placeholders.pammAccount': 'Enter PAMM Account Id',
  'accounts.addAccount.placeholders.associatedEmail': 'Enter Associated Email',
  
  // General
  'accounts.notAvailable': 'Not available',
  'accounts.addNewAccount': 'Add New Account',
};
